import React from 'react'
import second from './faq.css'
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
function FAQ({faqsArr}) {
  return (
    <>
    {
        faqsArr?.map((item, index)=>( 
            <div key={index} className='accordion-wp'>
      <Accordion sx={{background: "none", color: 'white'}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{color: 'white'}} />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          {item?.quest}
        </AccordionSummary>
        <AccordionDetails>
          {item?.ans}
        </AccordionDetails>
      </Accordion>
      </div>
        ))
    }
      
      
      
    </>
  )
}

export default FAQ